import { HEADER_HEIGHT } from '~/domains/common/components/AppShellHeader/constants';

/** Popular Picks grid/title horizontal bleed applies at max-width 413px (viewports under 414px). */
export const POPULAR_PICK_GRID_BLEED_MAX_WIDTH_PX = 413;

/** Figma Search Header (1440-wide frame): horizontal inset; row inner width = 1440 − 2×inset. */
export const BOARD_SEARCH_FRAME_INSET_PX = 142;

export const BOARD_SEARCH_ROW_MAX_WIDTH_PX = 1156;

export const BOARD_SEARCH_INPUT_ROW_HEIGHT_PX = 36;

export const BOARD_SEARCH_PANEL_VERTICAL_PADDING_PX =
  (HEADER_HEIGHT - BOARD_SEARCH_INPUT_ROW_HEIGHT_PX) / 2;

/** Fixed search toolbar vertical stack — matches `HEADER_HEIGHT` / BoardSearchPanel. */
export const BOARD_SEARCH_TOOLBAR_STACK_MD_UP_PX = HEADER_HEIGHT;

/** Same as above below `md`. */
export const BOARD_SEARCH_TOOLBAR_STACK_BELOW_MD_PX = HEADER_HEIGHT;
